import React, { useState } from "react";
import ReportTable from "../subComponents/reportTable";
import { columnsConfig } from "../reportColumns";
import ReportFilters from "../subComponents/reportFilter";

const StockMovementReport: React.FC = () => {
  const [filterInputs, setFilterInputs] = useState({
    fromDate: "",
    toDate: ""
  });

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: ""
  });

  const handleApplyFilters = () => {
    setFilters(filterInputs);
  };

  const handleResetFilters = () => {
    const empty = { fromDate: "", toDate: "" };
    setFilterInputs(empty);
    setFilters(empty);
  };

  return (
    <div>
      <ReportFilters
        filters={filterInputs}
        setFilters={setFilterInputs}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
      />
      <ReportTable
        title="Stock Movement Report"
        endpoint="reports/stock-movement"
        columns={columnsConfig.stockMovemntColumns}
        filters={filters}
      />
    </div>
  );
};

export default StockMovementReport;